function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMccGroceries = function SvgMccGroceries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.715 5.97a2 2 0 0 0-3.43 2.059l4.183 6.97H13.532l4.183-6.97a2 2 0 1 0-3.43-2.058L8.868 15H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1l1.781 14.248A2 2 0 0 0 7.766 35h24.468a2 2 0 0 0 1.985-1.752L36 19h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-5.868l-5.417-9.03ZM10.605 21a1 1 0 0 0-.995 1.1l.8 8a1 1 0 0 0 .995.9h.095a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-.895Zm8.946 0a1 1 0 0 0-.998 1.05l.4 8a1 1 0 0 0 .998.95h.098a1 1 0 0 0 .999-.95l.4-8a1 1 0 0 0-1-1.05h-.897Zm7.95 1a1 1 0 0 1 1-1h.894a1 1 0 0 1 .995 1.1l-.8 8a1 1 0 0 1-.995.9H28.5a1 1 0 0 1-1-1v-8Z",
    clipRule: "evenodd",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccGroceries;